import { InvoiceStatusEnum } from './enums/invoice-status.enum';
import { ColorEnum } from './enums/color.enum';

export class BasketOrderStatus {
  public code!: InvoiceStatusEnum;
  public translationKey!: string;
  public emoji!: string;
  public color!: ColorEnum;

  constructor(data: any = {}) {
    Object.assign(this, data);
  }
}

export const LIST_BASKET_ORDER_STATUS: any = {
  INIT: new BasketOrderStatus({ code: InvoiceStatusEnum.INIT, translationKey: 'INVOICE_STATUS.INIT', emoji: '🗓️', color: ColorEnum.INFO }),
  CANCELED: new BasketOrderStatus({ code: InvoiceStatusEnum.CANCELED, translationKey: 'INVOICE_STATUS.CANCELED', emoji: '🚫️', color: ColorEnum.DANGER }),
  ISSUED: new BasketOrderStatus({ code: InvoiceStatusEnum.ISSUED, translationKey: 'INVOICE_STATUS.ISSUED', emoji: '🚫️', color: ColorEnum.DANGER }),
  OFFLINE: new BasketOrderStatus({ code: InvoiceStatusEnum.OFFLINE, translationKey: 'INVOICE_STATUS.OFFLINE', emoji: '📴', color: ColorEnum.DANGER }),
  ACCEPTED: new BasketOrderStatus({ code: InvoiceStatusEnum.ACCEPTED, translationKey: 'INVOICE_STATUS.ACCEPTED', emoji: '🗓️', color: ColorEnum.INFO }),
  PAID: new BasketOrderStatus({ code: InvoiceStatusEnum.PAID, translationKey: 'INVOICE_STATUS.PAID', emoji: '🏆️', color: ColorEnum.SUCCESS }),
  BILLED: new BasketOrderStatus({ code: InvoiceStatusEnum.BILLED, translationKey: 'INVOICE_STATUS.BILLED', emoji: '🏆️', color: ColorEnum.SUCCESS }),
  LATE: new BasketOrderStatus({ code: InvoiceStatusEnum.LATE, translationKey: 'INVOICE_STATUS.LATE', emoji: '🕰️', color: ColorEnum.DANGER }),
};
